<template>
  <van-popup v-model="show" round>
    <div class="pop">
      <div class="box">
        <div class="title">
          <div class="left">{{$t('lang.t307')}}</div>
          <img class="right" src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/btnShare.png" alt="">
        </div>
        <div class="desc">{{$t('lang.t308')}}</div>
      </div>
      <div class="btn" @click="show=false">
        {{$t('lang.t309')}}
      </div>
    </div>
  </van-popup>
</template>
<script>
export default {
  name: '',
  props: {},
  components: {},
  data() {
    return {
      show: false,
    }
  },
  methods: {
    open() {
      this.show = true
    },
    close() {
      this.show = false
    },
  },
  mounted() {},
}
</script>
<style lang="less" scoped>
.pop {
  display: flex;
  flex-direction: column;
  width: 300px;
  height: 260px;
  background: #ffffff;
  border-radius: 10px;
  padding: 0 25px 25px;
  box-sizing: border-box;
  .box {
    margin: 72px auto 0;
    .title {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 17px;
      color: #9e9e9e;
      .right {
        display: block;
        width: 34px;
        height: 19px;
      }
    }
    .desc {
      font-size: 17px;
      margin-top: 5px;
      color: #9e9e9e;
      text-align: center;
    }
  }
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: auto;
    height: 44px;
    font-size: 15px;
    background: #00c4c9;
    border-radius: 6px;
    color: #fff;
  }
}
</style>